import { Box } from '@/components/Box';
import { LabradorComponent } from '@/types/component';
import { getChildrenCount } from '@/utils/getChildrenCount';
import { getViewportVisibilityClass } from '@/utils/getViewportVisibilityClass';
import { getLabStyle } from '@/utils/labStyle';
import { tw } from '@/utils/tw';
import { withBackgroundColor } from '@/utils/withBackgroundColor';

import { withGridSystem } from '@/utils/withGridSystem';
import { renderContentComponent } from 'modules/dynamic/components';
import { Fragment } from 'react';

export const LabradorBox: LabradorComponent = ({ type, meta, data, descendants, ...props }) => {
  if (!getChildrenCount(descendants)) {
    return null;
  }

  const style = getLabStyle(meta);

  const { contentIndex, backgroundColor, width, titlePosition } = meta;

  const bgColor = withBackgroundColor(backgroundColor);
  const columns = withGridSystem(width);
  const viewportVisibilityClass = getViewportVisibilityClass({
    viewportVisibility: meta.viewportVisibility,
    hideViewport: meta.hideViewport,
  });

  const content = descendants.map((child, index) => {
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  return (
    <Box
      options={{ style, className: tw.join(bgColor, columns, viewportVisibilityClass, 'lab') }}
      data-content-index={contentIndex}
      data-title-position={titlePosition}
      {...{ content }}
      {...props}
    />
  );
};
